import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { TranslateLoader, TranslateModule, TranslateService, TranslateStore } from '@ngx-translate/core';
import { AddServerComponent } from './signin/add-server/add-server.component';
import { SigninService } from './signin/signin.service';
import { GlobalService } from './global.config';
import { ShowHidePasswordComponent } from './signin/show-hide-password/show-hide-password.component';
import { DataManagementComponent } from './pages/data-management/data-management.component';
import { AlertManagementComponent } from './pages/alert-management/alert-management.component';
import { HeaderComponent } from './header/header.component';
import { RealtimeWorkerService } from './pages/realtime/realtime-worker.service';
import { InfoDeviceComponent } from './pages/realtime/popup-rt/info-device/info-device.component';
import { DashboradComponent } from './pages/realtime/dashborad/dashborad.component';
import { PointInteretComponent } from './pages/data-management/point-interet/point-interet.component';
import { SigninComponent } from './signin/signin.component';
import { MapService } from './utils/leaflet/service/map.service';
import { FaConfig, FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { RealtimeComponent } from './pages/realtime/realtime.component';
import { HistoricalComponent } from './pages/historical/historical.component';
import { ExpandableComponent } from './utils/expandable/expandable.component';
import { PromptComponent } from './pages/realtime/prompt/prompt.component';
import { NotificationsComponent } from './header/notifications/notifications.component';
import { PopupRtComponent } from './pages/realtime/popup-rt/popup-rt.component';
import { OrderByPipe } from './utils/pipes/order-by.pipe';
import { CapitalizeFirstPipe } from './utils/pipes/capitalizefirst.pipe';
import { GroupFilterPipe } from './utils/pipes/group-filter.pipe';
import { RoundPipe } from './utils/pipes/round.pipe';
import { ReversePipe } from './utils/pipes/reverse.pipe';
import { NoValuePipe } from './utils/pipes/no-value.pipe';
import { TruncatePipe } from './utils/pipes/truncate.pipe';
import { FilterByPipe } from './utils/pipes/filet-by.pipe';
import { GeocodingService } from './utils/leaflet/service/geocoding.service';
import { RealTimeService } from './pages/realtime/realtime.service';
import { PointInteretService } from './pages/data-management/point-interet/point-interet.service';
import { AuthGuard } from './utils/auth.guard';
import { LoadingService } from './utils/loading/loadingService';
import { LoadingInterceptor } from './utils/loading/interceptor';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { IonicPullupModule } from "ionic-pullup";
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { NgxPopperModule } from 'ngx-popper';
import { OverspeedModalComponent } from './pages/historical/overspeed/overspeed-modal/overspeed-modal.component';
import { MileageModalComponent } from './pages/historical/mileage/mileage-modal/mileage-modal.component';
import { StopModalComponent } from './pages/historical/stop/stop-modal/stop-modal.component';
import { CalendarModalComponent } from './pages/historical/calendar-modal/calendar-modal.component';
import { PathModalComponent } from './pages/historical/path/path-modal/path-modal.component';
import { MileageComponent } from './pages/historical/mileage/mileage.component';
import { OverspeedComponent } from './pages/historical/overspeed/overspeed.component';
import { StopComponent } from './pages/historical/stop/stop.component';
import { PathComponent } from './pages/historical/path/path.component';
import { AlertNotificationComponent } from './pages/alert-management/alert-notification/alert-notification.component';
import { NotificationBodyComponent } from './header/notifications/notification-body/notification-body.component';
import { FuelDataComponent } from './pages/statistical/fuel-data/fuel-data.component';
import { TechnicalDataComponent } from './pages/statistical/technical-data/technical-data.component';
import { TempDataComponent } from './pages/statistical/temp-data/temp-data.component';
import { SortByPipe } from './pipes/sort-by.pipe';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ToastrModule } from "ngx-toastr";
import { NgxDaterangepickerMd } from "ngx-daterangepicker-material";
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { StateService } from './utils/leaflet/service/state.service';
import { VideoService } from "./pages/realtime/video.service";
import { VideoComponent } from "./pages/realtime/video/video.component";
import { VideoEmergencyComponent } from "./pages/video-emergency/video-emergency.component";
import { VideoPlaybackHistoricalComponent } from "./pages/historical/video-playback/video-playback-historical.component";
import { DriverComponent } from "./pages/driver/driver.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { TrackControleComponent } from "./utils/leaflet/track-controle/track-controle.component";
import { TrackPlayerService } from "./utils/leaflet/service/track-player.service";
import { IMqttServiceOptions } from 'ngx-mqtt';
import { HistoricalSubmenuComponent } from './shared/components/historical-submenu/historical-submenu.component';
import { GraphicalReportSubmenuComponent } from './shared/components/graphical-report-submenu/graphical-report-submenu.component';
import { RtNavMenuPopoverComponent } from './shared/components/rt-nav-menu-popover/rt-nav-menu-popover.component';
import { HistoriqueMenuPopoverComponent } from './shared/components/historique-menu-popover/historique-menu-popover.component';
import { GraphicalReportMenuPopoverComponent } from './shared/components/graphical-report-menu-popover/graphical-report-menu-popover.component';
import { DraggableSheetComponent } from './shared/components/draggable-sheet/draggable-sheet.component';
import { RtBottomNavComponent } from './shared/components/rt-bottom-nav/rt-bottom-nav.component';
import { SearchStepperComponent } from './shared/components/search-stepper/search-stepper.component';
import { HistoriqueInfoBarComponent } from './shared/components/historique-info-bar/historique-info-bar.component';
import { MapControlsComponent } from './utils/map-controls/map-controls.component';
import { MapTopToolbarComponent } from './utils/map-top-toolbar/map-top-toolbar.component';
import { FloatingMenuComponent } from './utils/floating-menu/floating-menu.component';
import { MapLayerSelectorComponent } from './utils/map-layer-selector/map-layer-selector.component';

// AoT requires an exported function for factories
export const createTranslateLoader = (http: HttpClient) => {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
};
declare var require: any;

export const MQTT_SERVICE_OPTIONS: IMqttServiceOptions = {
  //hostname: '164.132.207.128',
  //port: 2884,
  username: 'in',
  password: 'in',
  //protocol: 'ws',

  //path: '/mqtt'
  connectOnCreate: false,
  url: "ws://traci.tn/ws/mqtt"
}

@NgModule({
  declarations: [
    VideoComponent,
    VideoPlaybackHistoricalComponent,
    DriverComponent,
    VideoEmergencyComponent,
    AppComponent,
    SigninComponent,
    HeaderComponent,
    RealtimeComponent,
    HistoricalComponent,
    PathComponent,
    StopComponent,
    OverspeedComponent,
    MileageComponent,
    PathModalComponent,
    CalendarModalComponent,
    StopModalComponent,
    MileageModalComponent,
    OverspeedModalComponent,
    FuelDataComponent,
    TechnicalDataComponent,
    TempDataComponent,
    ExpandableComponent,
    PromptComponent,
    DataManagementComponent,
    NotificationsComponent,
    NotificationBodyComponent,
    AlertManagementComponent,
    AlertNotificationComponent,
    DashboradComponent,
    AddServerComponent,
    PointInteretComponent,
    PopupRtComponent,
    OrderByPipe,
    CapitalizeFirstPipe,
    GroupFilterPipe,
    RoundPipe,
    ReversePipe,
    NoValuePipe,
    TruncatePipe,
    FilterByPipe,
    SortByPipe,
    ShowHidePasswordComponent,
    InfoDeviceComponent,
    TrackControleComponent,
    FloatingMenuComponent,
    MapTopToolbarComponent,
    HistoricalSubmenuComponent,
    GraphicalReportSubmenuComponent,
    RtNavMenuPopoverComponent,
    HistoriqueMenuPopoverComponent,
    GraphicalReportMenuPopoverComponent,
    DraggableSheetComponent,
    RtBottomNavComponent,
    SearchStepperComponent,
    HistoriqueInfoBarComponent,
    MapControlsComponent,
    MapLayerSelectorComponent
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    FontAwesomeModule,
    CommonModule,
    HttpClientModule,
    FormsModule,
    NgxPopperModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    IonicPullupModule,
    BrowserAnimationsModule,
    ModalModule.forRoot(),
    ToastrModule.forRoot(),
    NgxDaterangepickerMd.forRoot(),
    NgMultiSelectDropDownModule,
    TranslateModule,
    IonicModule
  ],
  providers: [
    StateService,
    VideoService,
    SigninService,
    GlobalService,
    MapService,
    RealtimeWorkerService,
    RealTimeService,
    GeocodingService,
    TranslateService,
    TranslateStore,
    PointInteretService,
    //AndroidPermissions,
    DecimalPipe,
    DatePipe,
    RoundPipe,
    Geolocation,
    AuthGuard,
    FaConfig,
    FaIconLibrary,
    TrackPlayerService,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    LoadingService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(library: FaIconLibrary) {
    library.addIconPacks(fas, fab, far);
  }
}
